import { render, staticRenderFns } from "./ImportWizardTable.vue?vue&type=template&id=5fdb93dd&scoped=true"
import script from "./ImportWizardTable.vue?vue&type=script&lang=js"
export * from "./ImportWizardTable.vue?vue&type=script&lang=js"
import style0 from "./ImportWizardTable.vue?vue&type=style&index=0&id=5fdb93dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdb93dd",
  null
  
)

export default component.exports